export const indiaVsNewzealandTeamsList = [
  {
    _id: '63cf7574e6b1ab001dcf8f72',
    createdOn: '2023-01-24T06:06:44.664Z',
    deletedOn: null,
    matchId: '63cbb6ed96851a4d7f84726c',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63cbb73896851a4d7f84845a',
    viceCaptainId: '63cbb73896851a4d7f848467',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63cbb73896851a4d7f848457',
        rating: 9,
        teamId: 7,
        role: 'wk'
      },
      {
        playerId: '63cbb73896851a4d7f848479',
        rating: 8.5,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '63cbb73896851a4d7f84845a',
        rating: 9,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cbb73896851a4d7f848467',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cbb73896851a4d7f84846a',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cbb73896851a4d7f848440',
        rating: 8.5,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cbb73896851a4d7f848446',
        rating: 9,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cbb73896851a4d7f848473',
        rating: 9,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63cbb73896851a4d7f848455',
        rating: 9,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63cbb73896851a4d7f848476',
        rating: 9,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63cbb73896851a4d7f848482',
        rating: 9,
        teamId: 25,
        role: 'bowl'
      }
    ],
    captain: {
      _id: '63cbb73896851a4d7f84845a',
      matchId: '63cbb6ed96851a4d7f84726c',
      playerId: '46141',
      battingStyle: 'Left hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Medium',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Devon Conway',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'New Zealand',
      playingEleven: false,
      playingRole: 'bat',
      points: 0,
      rating: 9,
      role: 'bat',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Devon Conway',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 7,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Devon Conway',
      twoWicketHaul: 0,
      wicket: 0,
      totalPointsOfPreviousMatches: 28,
      captainPercentage: 0,
      normalPercentage: 100,
      viceCaptainPercentage: 100
    },
    viceCaptain: {
      _id: '63cbb73896851a4d7f848467',
      matchId: '63cbb6ed96851a4d7f84726c',
      playerId: '115',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Off Break',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Rohit Sharma',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'India',
      playingEleven: false,
      playingRole: 'bat',
      points: 0,
      rating: 9,
      role: 'bat',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Rohit Sharma',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 25,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Rohit Sharma',
      twoWicketHaul: 0,
      wicket: 0,
      totalPointsOfPreviousMatches: 118,
      captainPercentage: 0,
      normalPercentage: 100,
      viceCaptainPercentage: 0
    },
    id: '63cf7574e6b1ab001dcf8f72'
  }
];

export const pakVsAusTeamsList = [
  {
    _id: '624c4bd2ef7a36001f872b3e',
    createdOn: '2022-04-05T14:01:54.776Z',
    deletedOn: null,
    matchId: '62487289bc54653691c41e41',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '62487296bc54653691c42edc',
    viceCaptainId: '62487296bc54653691c42ed8',
    score: 412.5,
    teamNumber: 1,
    players: [
      {
        playerId: '62487296bc54653691c42f12',
        rating: 9.5,
        teamId: 13,
        role: 'wk'
      },
      {
        playerId: '62487296bc54653691c42ecf',
        rating: 8.5,
        teamId: 5,
        role: 'wk'
      },
      {
        playerId: '62487296bc54653691c42ed4',
        rating: 9.5,
        teamId: 5,
        role: 'bat'
      },
      {
        playerId: '62487296bc54653691c42edc',
        rating: 9,
        teamId: 5,
        role: 'bat'
      },
      {
        playerId: '62487296bc54653691c42ed8',
        rating: 9,
        teamId: 5,
        role: 'bat'
      },
      {
        playerId: '62487296bc54653691c42f23',
        rating: 9,
        teamId: 13,
        role: 'bat'
      },
      {
        playerId: '62487296bc54653691c42ee8',
        rating: 9.5,
        teamId: 5,
        role: 'all'
      },
      {
        playerId: '62487296bc54653691c42eee',
        rating: 9,
        teamId: 5,
        role: 'all'
      },
      {
        playerId: '62487296bc54653691c42f47',
        rating: 9,
        teamId: 13,
        role: 'bowl'
      },
      {
        playerId: '62487296bc54653691c42f4f',
        rating: 9,
        teamId: 13,
        role: 'bowl'
      },
      {
        playerId: '62487296bc54653691c42efc',
        rating: 8.5,
        teamId: 5,
        role: 'bowl'
      }
    ],
    verifiedScore: 412.5,
    captain: {
      _id: '62487296bc54653691c42edc',
      matchId: '62487289bc54653691c41e41',
      playerId: '53601',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Leg Spin',
      catch: 1,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Marnus Labuschagne',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 14,
      maidenOver: 0,
      middleName: '',
      nationality: 'Australia',
      playingEleven: true,
      playingRole: 'bat',
      points: 14,
      rating: 9,
      role: 'bat',
      run: 2,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Marnus Labuschagne',
      six: 0,
      startingEleven: 1,
      strikeRate: 50,
      stump: 0,
      teamId: 5,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Marnus Labuschagne',
      twoWicketHaul: 0,
      wicket: 0
    },
    viceCaptain: {
      _id: '62487296bc54653691c42ed8',
      matchId: '62487289bc54653691c41e41',
      playerId: '73',
      battingStyle: 'Right Hand Bat',
      boundary: 6,
      bowlingStyle: 'Left Arm Orthodox',
      catch: 1,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Aaron Finch',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 1,
      lastName: '',
      lastPoints: 81,
      maidenOver: 0,
      middleName: '',
      nationality: 'Australia',
      playingEleven: true,
      playingRole: 'bat',
      points: 81,
      rating: 9,
      role: 'bat',
      run: 55,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'AJ Finch',
      six: 0,
      startingEleven: 1,
      strikeRate: 122.22,
      stump: 0,
      teamId: 5,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Aaron Finch',
      twoWicketHaul: 0,
      wicket: 0
    },
    id: '624c4bd2ef7a36001f872b3e'
  }
];

export const pakVsNzMyTeamsList = [
  {
    _id: '63c1095dd1aa43001dca66eb',
    createdOn: '2023-01-13T07:33:49.149Z',
    deletedOn: null,
    matchId: '63be86840901e17d0f43117e',
    userId: '5fd32b93eaf661ea51eae8af',
    tenant: 'gamio',
    username: 'RajasthanRoyals',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    middlename: null,
    captainId: '63be86fe0901e17d0f433095',
    viceCaptainId: '63be86fe0901e17d0f433096',
    score: 602.5,
    teamNumber: 1,
    players: [
      {
        playerId: '63be86fe0901e17d0f433060',
        rating: 9,
        teamId: 7,
        role: 'wk'
      },
      {
        playerId: '63be86fe0901e17d0f433063',
        rating: 8.5,
        teamId: 7,
        role: 'wk'
      },
      {
        playerId: '63be86fe0901e17d0f43307f',
        rating: 8.5,
        teamId: 13,
        role: 'wk'
      },
      {
        playerId: '63be86fe0901e17d0f433064',
        rating: 9,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63be86fe0901e17d0f433094',
        rating: 9,
        teamId: 13,
        role: 'bat'
      },
      {
        playerId: '63be86fe0901e17d0f433095',
        rating: 8.5,
        teamId: 13,
        role: 'bat'
      },
      {
        playerId: '63be86fe0901e17d0f433096',
        rating: 8.5,
        teamId: 13,
        role: 'bat'
      },
      {
        playerId: '63be86fe0901e17d0f43309b',
        rating: 8,
        teamId: 13,
        role: 'all'
      },
      {
        playerId: '63be86fe0901e17d0f43309d',
        rating: 9,
        teamId: 13,
        role: 'bowl'
      },
      {
        playerId: '63be86fe0901e17d0f433077',
        rating: 8.5,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63be86fe0901e17d0f43309f',
        rating: 8.5,
        teamId: 13,
        role: 'bowl'
      }
    ],
    verifiedScore: 602.5,
    captain: {
      _id: '63be86fe0901e17d0f433095',
      matchId: '63be86840901e17d0f43117e',
      playerId: '141',
      battingStyle: 'Left hand Bat',
      boundary: 1,
      bowlingStyle: 'Left Arm Orthodox',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Haris Sohail',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 27,
      maidenOver: 0,
      middleName: '',
      nationality: 'Pakistan',
      playingEleven: true,
      playingRole: 'bat',
      points: 27,
      rating: 8.5,
      role: 'bat',
      run: 22,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'H Sohail',
      six: 0,
      startingEleven: 1,
      strikeRate: 88,
      stump: 0,
      teamId: 13,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Haris Sohail',
      twoWicketHaul: 0,
      wicket: 0
    },
    viceCaptain: {
      _id: '63be86fe0901e17d0f433096',
      matchId: '63be86840901e17d0f43117e',
      playerId: '43370',
      battingStyle: 'Left hand Bat',
      boundary: 10,
      bowlingStyle: 'Left Arm Orthodox',
      catch: 0,
      century: 1,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Fakhar Zaman',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 125,
      maidenOver: 0,
      middleName: '',
      nationality: 'Pakistan',
      playingEleven: true,
      playingRole: 'bat',
      points: 125,
      rating: 8.5,
      role: 'bat',
      run: 101,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'FK Zaman',
      six: 1,
      startingEleven: 1,
      strikeRate: 82.79,
      stump: 0,
      teamId: 13,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Fakhar Zaman',
      twoWicketHaul: 0,
      wicket: 0
    },
    id: '63c1095dd1aa43001dca66eb'
  }
];
export const wiVsEngMyTeamsList = [
  {
    _id: '6231dc65a54e48872a0985d1',
    createdOn: '2022-03-16T12:47:33.707Z',
    deletedOn: null,
    matchId: '622ae1a182f394e16728d732',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    firstname: 'Kamal',
    lastname: 'Kamal',
    username: 'Kamal',
    captainId: '622ae1b082f394e16728de36',
    viceCaptainId: '622ae1b082f394e16728de24',
    score: 804,
    teamNumber: 1,
    players: [
      {
        playerId: '622ae1b082f394e16728de36',
        rating: 8.5,
        teamId: 490,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de24',
        rating: 8.5,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de00',
        rating: 9,
        teamId: 17,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de37',
        rating: 8,
        teamId: 490,
        role: 'bowl'
      },
      {
        playerId: '622ae1b082f394e16728de1b',
        rating: 8.5,
        teamId: 490,
        role: 'wk'
      },
      {
        playerId: '622ae1b082f394e16728de23',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de26',
        rating: 8.5,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728ddf0',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728dded',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      },
      {
        playerId: '622ae1b082f394e16728de2c',
        rating: 8.5,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '622ae1b082f394e16728ddf6',
        rating: 8.5,
        teamId: 17,
        role: 'bat'
      }
    ],
    verifiedScore: 804,
    captain: {
      _id: '622ae1b082f394e16728de36',
      matchId: '622ae1a182f394e16728d732',
      playerId: '51308',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Medium Fast',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Ollie Robinson',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'England',
      playingEleven: false,
      playingRole: 'bowl',
      points: 0,
      rating: 8.5,
      role: 'bowl',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Ollie Robinson',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 490,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Ollie Robinson',
      twoWicketHaul: 0,
      wicket: 0
    },
    viceCaptain: {
      _id: '622ae1b082f394e16728de24',
      matchId: '622ae1a182f394e16728d732',
      playerId: '1042',
      battingStyle: 'Right Hand Bat',
      boundary: 1,
      bowlingStyle: 'Right Arm Leg Spin',
      catch: 1,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Dan Lawrence',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 1,
      lastName: '',
      lastPoints: 192,
      maidenOver: 0,
      middleName: '',
      nationality: 'England',
      playingEleven: true,
      playingRole: 'bat',
      points: 192,
      rating: 8.5,
      role: 'bat',
      run: 41,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'DW Lawrence',
      six: 2,
      startingEleven: 1,
      strikeRate: 0,
      stump: 0,
      teamId: 490,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Dan Lawrence',
      twoWicketHaul: 0,
      wicket: 1
    },
    id: '622c82acff867e001dbb445e'
  }
];

export const saVsEngMyTeamsList = [
  {
    _id: '63d0fbab67b0c2001d35fb4e',
    createdOn: '2023-01-25T09:51:39.137Z',
    deletedOn: null,
    matchId: '63d0d9c596851a4d7f67dcd5',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63d0da0f96851a4d7f67e870',
    viceCaptainId: '63d0da0f96851a4d7f67e84b',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63d0da0f96851a4d7f67e849',
        rating: 9,
        teamId: 19,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e870',
        rating: 9,
        teamId: 490,
        role: 'wk'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84b',
        rating: 9,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e87d',
        rating: 9,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e852',
        rating: 8.5,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e876',
        rating: 8.5,
        teamId: 490,
        role: 'bat'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84d',
        rating: 8.5,
        teamId: 19,
        role: 'all'
      },
      {
        playerId: '63d0da0f96851a4d7f67e874',
        rating: 8.5,
        teamId: 490,
        role: 'all'
      },
      {
        playerId: '63d0da0f96851a4d7f67e84f',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e866',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63d0da0f96851a4d7f67e884',
        rating: 9,
        teamId: 490,
        role: 'bowl'
      }
    ],
    captain: {
      _id: '63d0da0f96851a4d7f67e870',
      matchId: '63d0d9c596851a4d7f67dcd5',
      playerId: '105',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: '',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Jos Buttler',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'England',
      playingEleven: false,
      playingRole: 'wk',
      points: 0,
      rating: 9,
      role: 'wk',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Jos Buttler',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 490,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Jos Buttler',
      twoWicketHaul: 0,
      wicket: 0,
      captainPercentage: 0,
      normalPercentage: 100,
      viceCaptainPercentage: 0
    },
    viceCaptain: {
      _id: '63d0da0f96851a4d7f67e84b',
      matchId: '63d0d9c596851a4d7f67dcd5',
      playerId: '167',
      battingStyle: 'Left hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Off Break',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'David Miller',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'South Africa',
      playingEleven: false,
      playingRole: 'bat',
      points: 0,
      rating: 9,
      role: 'bat',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'David Miller',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 19,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'David Miller',
      twoWicketHaul: 0,
      wicket: 0,
      captainPercentage: 100,
      normalPercentage: 100,
      viceCaptainPercentage: 0
    },
    id: '63d0fbab67b0c2001d35fb4e'
  }
];

export const indVsNzT20MyTeamsList = [
  {
    _id: '63d25d8267b0c2001d35fc06',
    createdOn: '2023-01-26T11:01:22.362Z',
    deletedOn: null,
    matchId: '63cf79bd96851a4d7f28b245',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63cf7a0996851a4d7f28bea4',
    viceCaptainId: '63cf7a0996851a4d7f28beb3',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63cf7a0996851a4d7f28beb8',
        rating: 8.5,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '63cf7a0996851a4d7f28bebb',
        rating: 8,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '63cf7a0996851a4d7f28bea4',
        rating: 9,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a0996851a4d7f28beb3',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a0996851a4d7f28bea5',
        rating: 8.5,
        teamId: 7,
        role: 'bat'
      },
      {
        playerId: '63cf7a0996851a4d7f28beb4',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63cf7a0996851a4d7f28beaa',
        rating: 8.5,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cf7a0996851a4d7f28bea7',
        rating: 8.5,
        teamId: 7,
        role: 'all'
      },
      {
        playerId: '63cf7a0996851a4d7f28beaf',
        rating: 8.5,
        teamId: 7,
        role: 'bowl'
      },
      {
        playerId: '63cf7a0996851a4d7f28beb7',
        rating: 8.5,
        teamId: 25,
        role: 'bowl'
      },
      {
        playerId: '63cf7a0996851a4d7f28bec0',
        rating: 8.5,
        teamId: 25,
        role: 'bowl'
      }
    ],
    captain: {
      _id: '63cf7a0996851a4d7f28bea4',
      matchId: '63cf79bd96851a4d7f28b245',
      playerId: '1082',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Off Break',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Glenn Phillips',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'New Zealand',
      playingEleven: false,
      playingRole: 'bat',
      points: 0,
      rating: 9,
      role: 'bat',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Glenn Phillips',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 7,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Glenn Phillips',
      twoWicketHaul: 0,
      wicket: 0,
      totalPointsOfPreviousMatches: 79
    },
    viceCaptain: {
      _id: '63cf7a0996851a4d7f28beb3',
      matchId: '63cf79bd96851a4d7f28b245',
      playerId: '598',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Off Break',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Suryakumar Yadav',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'India',
      playingEleven: false,
      playingRole: 'bat',
      points: 0,
      rating: 9,
      role: 'bat',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'SA Yadav',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 25,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Suryakumar Yadav',
      twoWicketHaul: 0,
      wicket: 0,
      totalPointsOfPreviousMatches: 91
    },
    id: '63d25d8267b0c2001d35fc06'
  }
];

export const indVsSlTestMyTeamsList = [
  {
    _id: '622c42a5ff867e001dbb43cb',
    createdOn: '2022-03-12T06:50:13.054Z',
    deletedOn: null,
    matchId: '6225783d17d940379f6d67d1',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Verma',
    middlename: null,
    captainId: '6225784a17d940379f6d6adf',
    viceCaptainId: '6225784a17d940379f6d6a92',
    score: 957.5,
    teamNumber: 4,
    players: [
      {
        playerId: '6225784a17d940379f6d6ab8',
        rating: 9,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '6225784a17d940379f6d6a77',
        rating: 8.5,
        teamId: 21,
        role: 'wk'
      },
      {
        playerId: '6225784a17d940379f6d6a79',
        rating: 9.5,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6ac5',
        rating: 9.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6a7c',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6aca',
        rating: 9,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '6225784a17d940379f6d6adf',
        rating: 9.5,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '6225784a17d940379f6d6a92',
        rating: 9,
        teamId: 21,
        role: 'all'
      },
      {
        playerId: '6225784a17d940379f6d6aa9',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      },
      {
        playerId: '6225784a17d940379f6d6aad',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      },
      {
        playerId: '6225784a17d940379f6d6aa4',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      }
    ],
    verifiedScore: 957.5,
    captain: {
      _id: '6225784a17d940379f6d6adf',
      matchId: '6225783d17d940379f6d67d1',
      playerId: '129',
      battingStyle: 'Right Hand Bat',
      boundary: 1,
      bowlingStyle: 'Right Arm Off Break',
      catch: 1,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Ravichandran Ashwin',
      fiveWicketHaul: 0,
      fourWicketHaul: 1,
      halfCentury: 0,
      lastName: '',
      lastPoints: 140,
      maidenOver: 0,
      middleName: '',
      nationality: 'India',
      playingEleven: true,
      playingRole: 'all',
      points: 140,
      rating: 9.5,
      role: 'all',
      run: 13,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Ravichandran Ashwin',
      six: 0,
      startingEleven: 1,
      strikeRate: 0,
      stump: 0,
      teamId: 25,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Ravichandran Ashwin',
      twoWicketHaul: 0,
      wicket: 4
    },
    viceCaptain: {
      _id: '6225784a17d940379f6d6a92',
      matchId: '6225783d17d940379f6d67d1',
      playerId: '43745',
      battingStyle: 'Right Hand Bat',
      boundary: 1,
      bowlingStyle: 'Right Arm Off Break',
      catch: 1,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Dhananjaya de Silva',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 91,
      maidenOver: 0,
      middleName: '',
      nationality: 'Sri Lanka',
      playingEleven: true,
      playingRole: 'all',
      points: 91,
      rating: 9,
      role: 'all',
      run: 4,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'D de Silva',
      six: 0,
      startingEleven: 1,
      strikeRate: 0,
      stump: 0,
      teamId: 21,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Dhananjaya de Silva',
      twoWicketHaul: 0,
      wicket: 1
    },
    id: '6229cc2b2527e9001f0ccdb3'
  }
];
export const indVsSaT20MyTeamsList = [
  {
    _id: '6339908769b991001fa1add6',
    createdOn: '2022-10-02T13:22:15.309Z',
    deletedOn: null,
    matchId: '63344fdc258445b807480bf7',
    userId: '5fd32b93eaf661ea51eae8af',
    tenant: 'gamio',
    username: 'RajasthanRoyals',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    middlename: null,
    captainId: '63345055258445b807483a76',
    viceCaptainId: '63345055258445b807483a46',
    score: 340,
    teamNumber: 6,
    players: [
      {
        playerId: '63345055258445b807483a57',
        rating: 8,
        teamId: 25,
        role: 'wk'
      },
      {
        playerId: '63345055258445b807483a60',
        rating: 8.5,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a3e',
        rating: 8,
        teamId: 19,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a66',
        rating: 8,
        teamId: 25,
        role: 'bat'
      },
      {
        playerId: '63345055258445b807483a73',
        rating: 8.5,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a76',
        rating: 8,
        teamId: 25,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a46',
        rating: 8,
        teamId: 19,
        role: 'all'
      },
      {
        playerId: '63345055258445b807483a49',
        rating: 9,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a4d',
        rating: 8,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a4f',
        rating: 8,
        teamId: 19,
        role: 'bowl'
      },
      {
        playerId: '63345055258445b807483a82',
        rating: 8,
        teamId: 25,
        role: 'bowl'
      }
    ],
    verifiedScore: 340,
    captain: {
      _id: '63345055258445b807483a76',
      matchId: '63344fdc258445b807480bf7',
      playerId: '129',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Off Break',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 9.25,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Ravichandran Ashwin',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 4,
      maidenOver: 0,
      middleName: '',
      nationality: 'India',
      playingEleven: true,
      playingRole: 'all',
      points: 4,
      rating: 8,
      role: 'all',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Ravichandran Ashwin',
      six: 0,
      startingEleven: 1,
      strikeRate: 0,
      stump: 0,
      teamId: 25,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Ravichandran Ashwin',
      twoWicketHaul: 0,
      wicket: 0
    },
    viceCaptain: {
      _id: '63345055258445b807483a46',
      matchId: '63344fdc258445b807480bf7',
      playerId: '406',
      battingStyle: 'Left hand Bat',
      boundary: 0,
      bowlingStyle: 'Left Arm Medium Fast',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 13.5,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Wayne Parnell',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: -2,
      maidenOver: 0,
      middleName: '',
      nationality: 'South Africa',
      playingEleven: true,
      playingRole: 'all',
      points: -2,
      rating: 8,
      role: 'all',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Wayne Parnell',
      six: 0,
      startingEleven: 1,
      strikeRate: 0,
      stump: 0,
      teamId: 19,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Wayne Parnell',
      twoWicketHaul: 0,
      wicket: 0
    },
    id: '6339908769b991001fa1add6'
  }
];
export const slVsAfgT20MyTeamsList = [
  {
    _id: '630a22ce8affc500207af0e3',
    createdOn: '2022-08-27T13:57:34.192Z',
    deletedOn: null,
    matchId: '630727157e2d41535f39f628',
    userId: '5fd32b93eaf661ea51eae8af',
    tenant: 'gamio',
    username: 'RajasthanRoyals',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    middlename: null,
    captainId: '6307271c7e2d41535f39f7ef',
    viceCaptainId: '6307271c7e2d41535f39f7e3',
    score: 385,
    teamNumber: 7,
    players: [
      {
        playerId: '6307271c7e2d41535f39f7c2',
        rating: 9,
        teamId: 498,
        role: 'wk'
      },
      {
        playerId: '6307271c7e2d41535f39f786',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f7cf',
        rating: 9,
        teamId: 498,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f78a',
        rating: 9,
        teamId: 21,
        role: 'bat'
      },
      {
        playerId: '6307271c7e2d41535f39f794',
        rating: 9.5,
        teamId: 21,
        role: 'all'
      },
      {
        playerId: '6307271c7e2d41535f39f798',
        rating: 9,
        teamId: 21,
        role: 'all'
      },
      {
        playerId: '6307271c7e2d41535f39f7e3',
        rating: 9,
        teamId: 498,
        role: 'all'
      },
      {
        playerId: '6307271c7e2d41535f39f7ef',
        rating: 9.5,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f7f3',
        rating: 9,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f7f6',
        rating: 8.5,
        teamId: 498,
        role: 'bowl'
      },
      {
        playerId: '6307271c7e2d41535f39f7a6',
        rating: 8.5,
        teamId: 21,
        role: 'bowl'
      }
    ],
    verifiedScore: 385,
    captain: {
      _id: '6307271c7e2d41535f39f7ef',
      matchId: '630727157e2d41535f39f628',
      playerId: '1157',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Leg Spin',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 3,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Rashid Khan',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 10,
      maidenOver: 0,
      middleName: '',
      nationality: 'Afghanistan',
      playingEleven: true,
      playingRole: 'bowl',
      points: 10,
      rating: 9.5,
      role: 'bowl',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Rashid Khan',
      six: 0,
      startingEleven: 1,
      strikeRate: 0,
      stump: 0,
      teamId: 498,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Rashid Khan',
      twoWicketHaul: 0,
      wicket: 0
    },
    viceCaptain: {
      _id: '6307271c7e2d41535f39f7e3',
      matchId: '630727157e2d41535f39f628',
      playerId: '319',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Off Break',
      catch: 1,
      century: 0,
      dismissal: 0,
      economyRate: 3.5,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Mohammad Nabi',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 74,
      maidenOver: 0,
      middleName: '',
      nationality: 'Afghanistan',
      playingEleven: true,
      playingRole: 'all',
      points: 74,
      rating: 9,
      role: 'all',
      run: 0,
      runOut: 1,
      runOutCatch: 1,
      runOutThrow: 0,
      shortName: 'Mohammad Nabi',
      six: 0,
      startingEleven: 1,
      strikeRate: 0,
      stump: 0,
      teamId: 498,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Mohammad Nabi',
      twoWicketHaul: 0,
      wicket: 2,
      lbwOrBowledWickets: 0
    },
    id: '630a22ce8affc500207af0e3'
  }
];
export const wiWVsIndWT20MyTeamsList = [
  {
    _id: '63d2687167b0c2001d35fc24',
    createdOn: '2023-01-26T11:48:01.202Z',
    deletedOn: null,
    matchId: '63cc017596851a4d7f92dbc2',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63cc01c296851a4d7f92ea4a',
    viceCaptainId: '63cc01c296851a4d7f92ea3b',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63cc01c296851a4d7f92ea4a',
        rating: 8.5,
        teamId: 9536,
        role: 'wk'
      },
      {
        playerId: '63cc01c296851a4d7f92ea3b',
        rating: 8,
        teamId: 9536,
        role: 'wk'
      },
      {
        playerId: '63cc01c296851a4d7f92ea37',
        rating: 9,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea38',
        rating: 9,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea59',
        rating: 8.5,
        teamId: 10272,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea42',
        rating: 8,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cc01c296851a4d7f92ea41',
        rating: 8.5,
        teamId: 9536,
        role: 'all'
      },
      {
        playerId: '63cc01c296851a4d7f92ea45',
        rating: 8.5,
        teamId: 9536,
        role: 'all'
      },
      {
        playerId: '63cc01c296851a4d7f92ea55',
        rating: 8.5,
        teamId: 10272,
        role: 'bowl'
      },
      {
        playerId: '63cc01c296851a4d7f92ea5f',
        rating: 8.5,
        teamId: 10272,
        role: 'bowl'
      },
      {
        playerId: '63cc01c296851a4d7f92ea65',
        rating: 8,
        teamId: 10272,
        role: 'bowl'
      }
    ],
    captain: {
      _id: '63cc01c296851a4d7f92ea4a',
      matchId: '63cc017596851a4d7f92dbc2',
      playerId: '47979',
      battingStyle: 'Left hand Bat',
      boundary: 0,
      bowlingStyle: 'Left Arm Orthodox',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Yastika Bhatia',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'India',
      playingEleven: false,
      playingRole: 'wk',
      points: 0,
      rating: 8.5,
      role: 'wk',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Yastika Bhatia',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 9536,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Yastika Bhatia',
      twoWicketHaul: 0,
      wicket: 0,
      totalPointsOfPreviousMatches: 103
    },
    viceCaptain: {
      _id: '63cc01c296851a4d7f92ea3b',
      matchId: '63cc017596851a4d7f92dbc2',
      playerId: '44718',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: '',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Sushma Verma',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'India',
      playingEleven: false,
      playingRole: 'wk',
      points: 0,
      rating: 8,
      role: 'wk',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'S Verma',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 9536,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Sushma Verma',
      twoWicketHaul: 0,
      wicket: 0,
      totalPointsOfPreviousMatches: 0
    },
    id: '63d2687167b0c2001d35fc24'
  }
];
export const indVsZimMyTeamsList = [
  {
    _id: '630086b94e80da001d0d7beb',
    createdOn: '2022-08-20T07:01:13.455Z',
    deletedOn: null,
    matchId: '62fdf2711f7aacc4e352a767',
    userId: '5fd32b93eaf661ea51eae8af',
    tenant: 'gamio',
    username: 'RajasthanRoyals',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    middlename: null,
    captainId: '62fdf27a1f7aacc4e3533185',
    viceCaptainId: '62fdf27a1f7aacc4e353318d',
    score: 608.5,
    teamNumber: 6,
    players: [
      {
        teamId: 493,
        role: 'wk',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e35331d7'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 10.5,
        playerId: '62fdf27a1f7aacc4e3533185'
      },
      {
        teamId: 25,
        role: 'bat',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353318d'
      },
      {
        teamId: 493,
        role: 'bat',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331f6'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9.5,
        playerId: '62fdf27a1f7aacc4e3533218'
      },
      {
        teamId: 493,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e353321c'
      },
      {
        teamId: 25,
        role: 'all',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e35331a0'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 9,
        playerId: '62fdf27a1f7aacc4e35331b2'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331bf'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331c7'
      },
      {
        teamId: 25,
        role: 'bowl',
        rating: 8.5,
        playerId: '62fdf27a1f7aacc4e35331cb'
      }
    ],
    verifiedScore: 608.5,
    captain: {
      _id: '62fdf27a1f7aacc4e3533185',
      matchId: '62fdf2711f7aacc4e352a767',
      playerId: '117',
      battingStyle: 'Left hand Bat',
      boundary: 4,
      bowlingStyle: 'Right Arm Off Break',
      catch: 1,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Shikhar Dhawan',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 55,
      maidenOver: 0,
      middleName: '',
      nationality: 'India',
      playingEleven: true,
      playingRole: 'bat',
      points: 55,
      rating: 10.5,
      role: 'bat',
      run: 33,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Shikhar Dhawan',
      six: 0,
      startingEleven: 1,
      strikeRate: 157.14,
      stump: 0,
      teamId: 25,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Shikhar Dhawan',
      twoWicketHaul: 0,
      wicket: 0
    },
    viceCaptain: {
      _id: '62fdf27a1f7aacc4e353318d',
      matchId: '62fdf2711f7aacc4e352a767',
      playerId: '90739',
      battingStyle: 'Right Hand Bat',
      boundary: 6,
      bowlingStyle: 'Right Arm Off Break',
      catch: 1,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Shubman Gill',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 51,
      maidenOver: 0,
      middleName: '',
      nationality: 'India',
      playingEleven: true,
      playingRole: 'bat',
      points: 51,
      rating: 9,
      role: 'bat',
      run: 33,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Shubman Gill',
      six: 0,
      startingEleven: 1,
      strikeRate: 97.06,
      stump: 0,
      teamId: 25,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Shubman Gill',
      twoWicketHaul: 0,
      wicket: 0
    },
    id: '630086b94e80da001d0d7beb'
  }
];
export const engWVsAusWU19MyTeamsList = [
  {
    _id: '63d28a42714ebb001dbb34ce',
    createdOn: '2023-01-26T14:12:18.635Z',
    deletedOn: null,
    matchId: '63d166dc96851a4d7f804920',
    userId: '5fd32b93eaf661ea51eae8af',
    tenant: 'gamio',
    username: 'RajasthanRoyals',
    firstname: 'Rajasthan',
    lastname: 'Royals',
    middlename: null,
    captainId: '63d1675696851a4d7f805b98',
    viceCaptainId: '63d1675696851a4d7f805b7f',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63d1675696851a4d7f805ba2',
        rating: 8.5,
        teamId: 127123,
        role: 'wk'
      },
      {
        playerId: '63d1675696851a4d7f805b8b',
        rating: 8.5,
        teamId: 127109,
        role: 'wk'
      },
      {
        playerId: '63d1675696851a4d7f805b81',
        rating: 9,
        teamId: 127109,
        role: 'bat'
      },
      {
        playerId: '63d1675696851a4d7f805b97',
        rating: 8.5,
        teamId: 127123,
        role: 'bat'
      },
      {
        playerId: '63d1675696851a4d7f805b9a',
        rating: 8.5,
        teamId: 127123,
        role: 'bat'
      },
      {
        playerId: '63d1675696851a4d7f805b98',
        rating: 9,
        teamId: 127123,
        role: 'all'
      },
      {
        playerId: '63d1675696851a4d7f805b7f',
        rating: 9,
        teamId: 127109,
        role: 'all'
      },
      {
        playerId: '63d1675696851a4d7f805b80',
        rating: 8.5,
        teamId: 127109,
        role: 'all'
      },
      {
        playerId: '63d1675696851a4d7f805b9c',
        rating: 8.5,
        teamId: 127123,
        role: 'bowl'
      },
      {
        playerId: '63d1675696851a4d7f805b85',
        rating: 8.5,
        teamId: 127109,
        role: 'bowl'
      },
      {
        playerId: '63d1675696851a4d7f805ba5',
        rating: 8.5,
        teamId: 127123,
        role: 'bowl'
      }
    ],
    captain: {
      _id: '63d1675696851a4d7f805b98',
      matchId: '63d166dc96851a4d7f804920',
      playerId: '102763',
      battingStyle: '',
      boundary: 0,
      bowlingStyle: '',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Grace Scrivens',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'England',
      playingEleven: false,
      playingRole: 'all',
      points: 0,
      rating: 9,
      role: 'all',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Grace Scrivens',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 127123,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Grace Scrivens',
      twoWicketHaul: 0,
      wicket: 0
    },
    viceCaptain: {
      _id: '63d1675696851a4d7f805b7f',
      matchId: '63d166dc96851a4d7f804920',
      playerId: '103927',
      battingStyle: '',
      boundary: 0,
      bowlingStyle: '',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Ella Hayward',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'Australia',
      playingEleven: false,
      playingRole: 'all',
      points: 0,
      rating: 9,
      role: 'all',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Ella Hayward',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 127109,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Ella Hayward',
      twoWicketHaul: 0,
      wicket: 0
    },
    id: '63d28a42714ebb001dbb34ce'
  }
];
export const saWVsIndWMyTeamsList = [
  {
    _id: '63d2ab1967b0c2001d35fc76',
    createdOn: '2023-01-26T16:32:25.614Z',
    deletedOn: null,
    matchId: '63cbff1d96851a4d7f92725d',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63cbff6996851a4d7f9285b1',
    viceCaptainId: '63cbff6996851a4d7f9285fd',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63cbff6996851a4d7f9285c2',
        rating: 8.5,
        teamId: 9536,
        role: 'wk'
      },
      {
        playerId: '63cbff6996851a4d7f9285aa',
        rating: 9,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285e6',
        rating: 9,
        teamId: 10279,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285d6',
        rating: 8.5,
        teamId: 10279,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285b6',
        rating: 8,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285c9',
        rating: 8,
        teamId: 9536,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285fd',
        rating: 8,
        teamId: 10279,
        role: 'bat'
      },
      {
        playerId: '63cbff6996851a4d7f9285b1',
        rating: 9,
        teamId: 9536,
        role: 'all'
      },
      {
        playerId: '63cbff6996851a4d7f9285ac',
        rating: 8.5,
        teamId: 9536,
        role: 'bowl'
      },
      {
        playerId: '63cbff6996851a4d7f9285bf',
        rating: 8.5,
        teamId: 9536,
        role: 'bowl'
      },
      {
        playerId: '63cbff6996851a4d7f9285da',
        rating: 8.5,
        teamId: 10279,
        role: 'bowl'
      }
    ],
    captain: {
      _id: '63cbff6996851a4d7f9285b1',
      matchId: '63cbff1d96851a4d7f92725d',
      playerId: '44740',
      battingStyle: 'Left hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Off Break',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Deepti Sharma',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'India',
      playingEleven: false,
      playingRole: 'all',
      points: 0,
      rating: 9,
      role: 'all',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Deepti Sharma',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 9536,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Deepti Sharma',
      twoWicketHaul: 0,
      wicket: 0,
      totalPointsOfPreviousMatches: 203,
      captainPercentage: 100,
      normalPercentage: 100,
      viceCaptainPercentage: 0
    },
    viceCaptain: {
      _id: '63cbff6996851a4d7f9285fd',
      matchId: '63cbff1d96851a4d7f92725d',
      playerId: '104665',
      battingStyle: 'Right Hand Bat',
      boundary: 0,
      bowlingStyle: 'Right Arm Medium',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Anneke Bosch',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'South Africa',
      playingEleven: false,
      playingRole: 'bat',
      points: 0,
      rating: 8,
      role: 'bat',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Anneke Bosch',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 10279,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Anneke Bosch',
      twoWicketHaul: 0,
      wicket: 0,
      totalPointsOfPreviousMatches: 13,
      captainPercentage: 0,
      normalPercentage: 0,
      viceCaptainPercentage: 0
    },
    id: '63d2ab1967b0c2001d35fc76'
  }
];
export const indWVsNzWU19MyTeamsList = [
  {
    _id: '63d2ace067b0c2001d35fc80',
    createdOn: '2023-01-26T16:40:00.656Z',
    deletedOn: null,
    matchId: '63d1792496851a4d7f831eb1',
    userId: '601cd58656c4dd5b565191e9',
    tenant: 'dev',
    username: 'Kamal',
    firstname: 'Kamal',
    lastname: 'Vermag',
    middlename: null,
    captainId: '63d1796f96851a4d7f832b22',
    viceCaptainId: '63d1796f96851a4d7f832afd',
    score: 0,
    teamNumber: 1,
    players: [
      {
        playerId: '63d1796f96851a4d7f832af1',
        rating: 8.5,
        teamId: 126918,
        role: 'wk'
      },
      {
        playerId: '63d1796f96851a4d7f832aec',
        rating: 8.5,
        teamId: 126918,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b22',
        rating: 8.5,
        teamId: 126969,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832afd',
        rating: 8,
        teamId: 126918,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b0a',
        rating: 8,
        teamId: 126918,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b1f',
        rating: 8,
        teamId: 126969,
        role: 'bat'
      },
      {
        playerId: '63d1796f96851a4d7f832b05',
        rating: 9,
        teamId: 126918,
        role: 'all'
      },
      {
        playerId: '63d1796f96851a4d7f832af4',
        rating: 8.5,
        teamId: 126918,
        role: 'bowl'
      },
      {
        playerId: '63d1796f96851a4d7f832b10',
        rating: 8.5,
        teamId: 126918,
        role: 'bowl'
      },
      {
        playerId: '63d1796f96851a4d7f832b27',
        rating: 8.5,
        teamId: 126969,
        role: 'bowl'
      },
      {
        playerId: '63d1796f96851a4d7f832b28',
        rating: 8.5,
        teamId: 126969,
        role: 'bowl'
      }
    ],
    captain: {
      _id: '63d1796f96851a4d7f832b22',
      matchId: '63d1792496851a4d7f831eb1',
      playerId: '122222',
      battingStyle: '',
      boundary: 0,
      bowlingStyle: '',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Shweta Sanjay Sehrawat',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: null,
      playingEleven: false,
      playingRole: 'bat',
      points: 0,
      rating: 8.5,
      role: 'bat',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Shweta Sehrawat',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 126969,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Shweta Sanjay Sehrawat',
      twoWicketHaul: 0,
      wicket: 0,
      totalPointsOfPreviousMatches: 27
    },
    viceCaptain: {
      _id: '63d1796f96851a4d7f832afd',
      matchId: '63d1792496851a4d7f831eb1',
      playerId: '113431',
      battingStyle: '',
      boundary: 0,
      bowlingStyle: '',
      catch: 0,
      century: 0,
      dismissal: 0,
      economyRate: 0,
      fieldingPosition: '',
      fiftyRuns: 0,
      firstName: 'Emma Irwin',
      fiveWicketHaul: 0,
      fourWicketHaul: 0,
      halfCentury: 0,
      lastName: '',
      lastPoints: 0,
      maidenOver: 0,
      middleName: '',
      nationality: 'New Zealand',
      playingEleven: false,
      playingRole: 'bat',
      points: 0,
      rating: 8,
      role: 'bat',
      run: 0,
      runOut: 0,
      runOutCatch: 0,
      runOutThrow: 0,
      shortName: 'Emma Irwin',
      six: 0,
      startingEleven: 0,
      strikeRate: 0,
      stump: 0,
      teamId: 126918,
      thirtyRuns: 0,
      threeWicketHaul: 0,
      thumbUrl: '',
      title: 'Emma Irwin',
      twoWicketHaul: 0,
      wicket: 0,
      totalPointsOfPreviousMatches: 0
    },
    id: '63d2ace067b0c2001d35fc80'
  }
];
